export default "__VITE_ASSET__df8554a9__"